import { useQuery } from 'react-query'
import { getContactAddress } from '../../../api/GET/contactAddress'
import { useDispatch } from 'react-redux'
import { resetAllContactAddress, resetContactAddress, setFetched } from '../../../slices/contactAddressSlice'

export const useQueryContactAddress = () => {
  const dispatch = useDispatch()
  return useQuery({
    queryKey: 'contactAddresses',
    queryFn: getContactAddress,
    staleTime: 0,
    onError: () => {
      // err.response.status === 404(Not Found)の場合、アドレス帳データなし
      dispatch(resetAllContactAddress([]))
      dispatch(resetContactAddress([]))
      dispatch(setFetched())
    },
  })
}
